import React from "react";
import { useNavigate } from "react-router-dom";
import './UseCases.css';

const UseCasesPage = ({ use_cases }) => {
  const navigate = useNavigate();

  return (
    <div className="use-cases-page">
      <header className="page-header">
        <button onClick={() => navigate('/')} className="back-button">
          <i className="fas fa-arrow-left"></i> Back
        </button>
      </header>
      <section className="use-cases-section">
        <h2 className="use-cases-title">Use Cases</h2>
        <div className="use-cases-list">
          {use_cases.map((useCase) => (
            <div className="use-case-card" key={useCase.id}>
              <div className="use-case-video-wrapper">
                <video 
                  src={useCase.video_url}
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="use-case-video"
                  alt={useCase.title}
                  loading="lazy"
                />
              </div>
              <div className="use-case-content">
                <h3 className="use-case-title">{useCase.title}</h3>
                <span className="use-case-mode">{useCase.mode}</span>
                <p className="use-case-description">{useCase.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default UseCasesPage; 